import { render } from "./TabContainer.vue?vue&type=template&id=1b55a116"
import script from "./TabContainer.vue?vue&type=script&lang=js"
export * from "./TabContainer.vue?vue&type=script&lang=js"

import "./TabContainer.vue?vue&type=style&index=0&id=1b55a116&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__